<app-header></app-header>
<app-sidebar></app-sidebar>
<app-right-sidebar></app-right-sidebar>
<div style="min-height: 90vh">
    <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
